import { HttpClient } from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';
import { BaseApiService } from '../base.service';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserJobSearchService extends BaseApiService {
  constructor(http: HttpClient) {
    const apiBaseUrl = isDevMode() ? '/navigate-api' : environment.navigateApiUrl;
    super(http, apiBaseUrl);
  }

  getUserJobListing(): Observable<any> {
    return this.get<any>('job-search');
  }

  getFilteredJobListing(
    sortBy: string,
    role: string, 
    location: string, 
    education: string,
    is_bookmarked: boolean, 
    is_related_to_career_goal: boolean
  ): Observable<any> {
    const roleParam = role ? `role=${encodeURIComponent(role)}` : '';
    const locationParam = location ? `location=${encodeURIComponent(location)}` : '';
    const educationParam = education ? `education=${encodeURIComponent(education)}` : '';
    const bookmarkParam = `bookmarked=${encodeURIComponent(is_bookmarked)}`;
    const careerGoalParam = `related_to_career_goal=${encodeURIComponent(is_related_to_career_goal)}`;
    const sortParam = sortBy ? `sort_by=${encodeURIComponent(sortBy)}` : '';

    const queryParams = [
      roleParam, 
      locationParam, 
      educationParam,
      bookmarkParam, 
      careerGoalParam
    ].filter(param => param).join('&');
    let jobSearchUrl = queryParams ? 'job-search?' + queryParams : 'job-search';

    jobSearchUrl =  sortBy != 'match_score_category' && sortBy !== 'match_score' ? jobSearchUrl + (queryParams ? '&' : '?') + sortParam : jobSearchUrl;

    return this.get<any>(jobSearchUrl);
  }

  getSortedJobListing(
    sortBy: string,
    role: string,
    location: string,
    education: string,
    is_bookmarked: boolean,
    is_related_to_career_goal: boolean,
  ): Observable<any> {
    /**
     * add sortBy query param if sortBy is not 'match_score_category'
     * because 'match_score_category' is the default sorting and doesn't require a query param
     */

    const roleParam = role ? `role=${encodeURIComponent(role)}` : '';
    const locationParam = location ? `location=${encodeURIComponent(location)}` : '';
    const educationParam = education ? `education=${encodeURIComponent(education)}` : '';
    const bookmarkParam = `bookmarked=${encodeURIComponent(is_bookmarked)}`;
    const careerGoalParam = `related_to_career_goal=${encodeURIComponent(is_related_to_career_goal)}`;
    const sortParam = sortBy ? `sort_by=${encodeURIComponent(sortBy)}` : '';

      const queryParams = [
      roleParam, 
      locationParam, 
      educationParam,
      bookmarkParam, 
      careerGoalParam,
    ].filter(param => param).join('&');
   

    let jobSearchUrl =  queryParams ? 'job-search?' + queryParams : 'job-search';

    jobSearchUrl =  sortBy != 'match_score_category' ? jobSearchUrl + (queryParams ? '&' : '?') + sortParam : jobSearchUrl;

    return this.get<any>(jobSearchUrl);
  }
}
